export const sanitization = (value) => {
    let result = value.replace( /^\s*(\[\s*url\s*=\s*)?(https?:\/\/)?(http?:\/\/)?(www\.|\S+?\.)(\S+?\.)?\S+\s*$\s*/gm,
    "");
    return result;
}